// SP: shared sliding hover indicator for the desktop merged nav
// (#main-nav, 992px+). Styling/transition lives in sp-header-responsive.css.
// A single line glides between top-level nav items on hover instead of
// each item independently fading in its own static underline — the
// "follows the direction" feel comes for free from animating left/width
// with CSS, no directional logic needed here.
(function () {
  function init() {
    var container = document.querySelector('#main-nav .navigation__tier-1-container');
    if (!container) return;

    var links = container.querySelectorAll('.navigation__tier-1 > .navigation__item > .navigation__link');
    if (!links.length) return;

    var indicator = document.createElement('span');
    indicator.className = 'sp-nav-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    container.appendChild(indicator);

    function activeLink() {
      var activeItem = container.querySelector('.navigation__tier-1 > .navigation__item--active');
      // querySelector returns document-order matches; the top-level
      // .navigation__link is rendered before the item's own
      // .navigation__tier-2-container, so this can't accidentally
      // match a nested dropdown link.
      return activeItem ? activeItem.querySelector('.navigation__link') : null;
    }

    function place(link, opts) {
      if (!link) return;
      opts = opts || {};
      var cs = getComputedStyle(link);
      var padLeft = parseFloat(cs.paddingLeft) || 0;
      var padRight = parseFloat(cs.paddingRight) || 0;

      if (opts.instant) indicator.classList.add('sp-nav-indicator--instant');

      indicator.style.left = link.offsetLeft + padLeft + 'px';
      indicator.style.width = link.offsetWidth - padLeft - padRight + 'px';

      // The comp (Figma 2140:11767 inside frame 1840:10619) sits the bar
      // FLUSH on the nav row's bottom divider — bar y=87..92, mega menu
      // starts at exactly 92 — for BOTH the open/hovered item and the
      // active one. So anchor to the row's bottom edge rather than to a
      // gap under the text. The comp's 24px text-to-bar gap is a
      // consequence of its 92px row (42 + 21 + 24 + 5 = 92); reproducing
      // that number literally on our 68px row pushed the bar out of the
      // row entirely.
      //
      // getBoundingClientRect, not clientHeight: the row measures 67.5px
      // and clientHeight rounds up to 68, leaving a half-pixel overhang
      // that renders as a visible 1px drop.
      indicator.style.top =
        container.getBoundingClientRect().height - indicator.offsetHeight + 'px';
      indicator.classList.add('sp-nav-indicator--visible');

      if (opts.instant) {
        // force reflow so the instant position takes before re-enabling transitions
        void indicator.offsetHeight;
        indicator.classList.remove('sp-nav-indicator--instant');
      }
    }

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        place(link);
      });
      link.addEventListener('focus', function () {
        place(link);
      });
    });

    container.addEventListener('mouseleave', function () {
      var resting = activeLink();
      if (resting) {
        place(resting);
      } else {
        indicator.classList.remove('sp-nav-indicator--visible');
      }
    });

    // Initial state: settle under the active item with a quiet fade,
    // no slide-in from the edge.
    place(activeLink(), { instant: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!indicator.classList.contains('sp-nav-indicator--visible')) return;
        place(document.activeElement && container.contains(document.activeElement) ? document.activeElement : activeLink(), { instant: true });
      }, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
